// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4aec08c5","977":"042c8deb"}[chunkId] + ".chunk.js";
};